import { StudentNotesPanel } from '../../features/notes/StudentNotesPanel';
import { formatClock, formatDuration } from '../../features/pilotMath/format';
import { pilotSummary } from '../../features/pilotMath/store';
import { usePilotState } from '../../features/pilotMath/usePilotState';
import { usePilotLearnerRecord } from '../../features/pilotMath/usePilotLearnerRecord';
import { flattenLearnerAttempts, learnerHistorySummary } from '../../features/pilotMath/learnerHistory';

export function ParentProgressPage() {
  const [state] = usePilotState();
  const summary = pilotSummary(state);
  const learner = usePilotLearnerRecord();
  const historySummary = learnerHistorySummary(learner);
  const allAttempts = flattenLearnerAttempts(learner);
  const skills = Object.values(learner.progress).filter((skill) => skill.evidenceCount > 0);

  return (
    <div className="stack">
      <div><h1>Detail Progress {state.student.displayName}</h1><p className="muted">Orang tua melihat ringkasan yang relevan tanpa hak mengubah mastery atau nilai.</p></div>
      <section className="grid grid--3">
        <div className="metric"><span>First-attempt hari ini</span><strong>{summary.firstAttemptAccuracy}%</strong></div>
        <div className="metric"><span>Hari belajar</span><strong>{historySummary.learningDays}</strong></div>
        <div className="metric"><span>Waktu aktif total</span><strong>{formatDuration(historySummary.totalActiveMs)}</strong></div>
      </section>
      <section className="card">
        <h2>Perkembangan skill</h2>
        <div className="skill-list">
          {skills.map((skill) => (
            <div className="skill-row" key={skill.skillCode}>
              <div><strong>{skill.label}</strong><div className="muted skill-code">{skill.skillCode}</div></div>
              <div className="skill-mastery"><strong>{skill.masteryPercent}%</strong><span className="muted">{skill.evidenceCount} evidence</span></div>
            </div>
          ))}
          {skills.length === 0 && <p className="muted">Belum ada evidence belajar hari ini.</p>}
        </div>
      </section>
      <section className="card">
        <h2>Aktivitas terakhir</h2>
        <div className="history-list">
          {allAttempts.slice(0, 6).map((attempt) => (
            <article className="history-item" key={attempt.id}>
              <div><strong>{attempt.skillLabel}</strong><div className="muted">{attempt.firstAttemptCorrect ? 'Benar pada jawaban pertama' : 'Selesai setelah koreksi'}</div></div>
              <div className="history-item__detail"><span>{formatDuration(attempt.duration.activeDurationMs)}</span><span>{formatClock(attempt.completedAt)}</span></div>
            </article>
          ))}
          {allAttempts.length === 0 && <p className="muted">Belum ada aktivitas.</p>}
        </div>
      </section>
      <StudentNotesPanel studentId={state.student.id} viewerRole="guardian" authorName="Orang Tua Andi" allowCreate defaultNoteType="parent" subjectCode="MTH" />
    </div>
  );
}
